import React, { useState } from "react";

import classNames from "classnames";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { IProductColor, IViewImage } from "../interfaces/IProduct";
import { setSelectedView } from "../store/slices/viewSlice";
import { IView } from "../interfaces/IView";

interface ViewThumbnailsProp {}

const MobileViewThumbnails: React.FC<ViewThumbnailsProp> = ({}) => {
  const [show, setShow] = useState(false);
  const dispatch = useAppDispatch();
  const viewData = useAppSelector(
    (state: any) => state.canvases.original_view_data
  );
  const selectedColor: IProductColor = useAppSelector(
    (state: any) => state.product.selected_color
  );
  const selectedViewId = useAppSelector(
    (state: any) => state.canvases.selectedViewId
  );
  const getViewImage: any = (viewId: string) => {
    let viewInfo: IViewImage | null = null;
    for (let index = 0; index < selectedColor.views.length; index++) {
      const view = selectedColor.views[index];
      if (view.id === viewId) {
        viewInfo = view;
      }
    }

    return viewInfo?.img;
  };
  return (
    <>
      <button
        onClick={() => {
          setShow(!show);
        }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="32"
            height="32"
            rx="16"
            fill="black"
            fillOpacity="0.32"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.1253 21.7779C21.9867 21.2426 24 19.8166 24 17.9999C24 16.8979 23.252 15.9273 21.9967 15.2159C21.8429 15.1303 21.6616 15.1088 21.4921 15.1564C21.3227 15.2039 21.1789 15.3165 21.0921 15.4696C21.0054 15.6227 20.9827 15.8039 21.029 15.9737C21.0753 16.1435 21.1868 16.2881 21.3393 16.3759C22.2173 16.8739 22.6667 17.4559 22.6667 17.9999C22.6667 18.9873 21.186 20.0359 18.88 20.4673C18.7062 20.4998 18.5524 20.6 18.4525 20.7459C18.3526 20.8918 18.3148 21.0714 18.3473 21.2453C18.3799 21.4191 18.4801 21.5728 18.626 21.6727C18.7719 21.7726 18.9515 21.8105 19.1253 21.7779ZM10.914 15.4666C11.001 15.6204 11.0233 15.8023 10.9762 15.9726C10.9291 16.1428 10.8163 16.2874 10.6627 16.3746C9.78267 16.8733 9.33333 17.4559 9.33333 17.9999C9.33333 19.0439 10.956 20.1093 13.3333 20.5053V19.4719C13.3332 19.4059 13.3527 19.3413 13.3893 19.2864C13.4259 19.2315 13.478 19.1887 13.539 19.1634C13.6 19.1381 13.6671 19.1315 13.7319 19.1444C13.7966 19.1573 13.856 19.1892 13.9027 19.2359L15.764 21.0973C15.795 21.1282 15.8197 21.165 15.8365 21.2055C15.8533 21.246 15.8619 21.2894 15.8619 21.3333C15.8619 21.3771 15.8533 21.4205 15.8365 21.461C15.8197 21.5015 15.795 21.5383 15.764 21.5693L13.9027 23.4306C13.8561 23.4773 13.7967 23.5091 13.732 23.522C13.6673 23.535 13.6003 23.5284 13.5393 23.5032C13.4784 23.478 13.4263 23.4353 13.3896 23.3805C13.3529 23.3257 13.3333 23.2612 13.3333 23.1953V21.8553C10.26 21.4019 8 19.9233 8 17.9999C8 16.8973 8.74867 15.9266 10.0053 15.2146C10.0815 15.1715 10.1655 15.1438 10.2524 15.1331C10.3393 15.1224 10.4275 15.1289 10.5119 15.1524C10.5963 15.1758 10.6752 15.2155 10.7442 15.2695C10.8132 15.3234 10.8709 15.3904 10.914 15.4666ZM14 9.33325C14.1768 9.33325 14.3464 9.40349 14.4714 9.52851C14.5964 9.65354 14.6667 9.82311 14.6667 9.99992C14.6667 10.3535 14.8071 10.6927 15.0572 10.9427C15.3072 11.1928 15.6464 11.3333 16 11.3333C16.3536 11.3333 16.6928 11.1928 16.9428 10.9427C17.1929 10.6927 17.3333 10.3535 17.3333 9.99992L17.338 9.92192C17.3571 9.75975 17.4351 9.61023 17.5571 9.50173C17.6791 9.39322 17.8367 9.33327 18 9.33325H21.3333C21.687 9.33325 22.0261 9.47373 22.2761 9.72378C22.5262 9.97382 22.6667 10.313 22.6667 10.6666V12.6666C22.6667 13.0202 22.5262 13.3593 22.2761 13.6094C22.0261 13.8594 21.687 13.9999 21.3333 13.9999H20V18.3333C20 18.5101 19.9298 18.6796 19.8047 18.8047C19.6797 18.9297 19.5101 18.9999 19.3333 18.9999C19.1565 18.9999 18.987 18.9297 18.8619 18.8047C18.7369 18.6796 18.6667 18.5101 18.6667 18.3333V13.9999C18.6667 13.6463 18.8071 13.3072 19.0572 13.0571C19.3072 12.8071 19.6464 12.6666 20 12.6666H21.3333V10.6666H18.5827C18.4344 11.2387 18.1003 11.7455 17.6328 12.1072C17.1654 12.4689 16.5911 12.6652 16 12.6652C15.4089 12.6652 14.8346 12.4689 14.3672 12.1072C13.8997 11.7455 13.5656 11.2387 13.4173 10.6666H10.6667V12.6666H12C12.3536 12.6666 12.6928 12.8071 12.9428 13.0571C13.1929 13.3072 13.3333 13.6463 13.3333 13.9999V18.3333C13.3333 18.5101 13.2631 18.6796 13.1381 18.8047C13.013 18.9297 12.8435 18.9999 12.6667 18.9999C12.4899 18.9999 12.3203 18.9297 12.1953 18.8047C12.0702 18.6796 12 18.5101 12 18.3333V13.9999H10.6667C10.313 13.9999 9.97391 13.8594 9.72386 13.6094C9.47381 13.3593 9.33333 13.0202 9.33333 12.6666V10.6666C9.33333 10.313 9.47381 9.97382 9.72386 9.72378C9.97391 9.47373 10.313 9.33325 10.6667 9.33325H14Z"
            fill="white"
          />
        </svg>
      </button>

      {show ? (
        <div className="m-2 mt-5 absolute right-7 bg-white  ">
          {viewData &&
            viewData.length &&
            viewData.map((view: IView, index: any) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    dispatch(setSelectedView(view.id));
                  }}
                  className="w-[150px]  bg-white p-2 mb-2 "
                >
                  <button
                    className="flex gap-3 align-middle justify-center align-middle"
                    style={{ alignItems: "center" }}
                  >
                    <div className="bg-[#d8d8d8]  flex">
                      <img
                        className="w-[50px]"
                        src={!selectedColor ? view.img : getViewImage(view.id)}
                        alt=""
                      />
                    </div>
                    <p
                      className={classNames("text-xs border-b-2 border-solid", {
                        ["border-primaryred"]: selectedViewId == view.id,
                        ["border-transparent"]: selectedViewId != view.id,
                      })}
                    >
                      {view.name}
                    </p>
                  </button>
                </div>
              );
            })}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default MobileViewThumbnails;
